export const WifiInitialData = {
  payload: {
    name: "",
    ssid: "",
    wifi_pass: "",
    network_type: "NONE",
  },
};
